<template>
  <div class="article" :class="{ isiOSX: isiOSX }">
    <van-nav-bar
      class="article-title"
      :fixed="true"
      title="销巴资讯"
      right-text="全部已读"
      @click-right="allRead"
    />
    <img
      @click="goBack()"
      class="article-reback"
      src="../../../assets/myInvest/reback.png"
    />
    <div class="article-content">
      <div id="list-content">
        <div class="loading" v-if="!isLoadingEnd">
          <img src="./../../../assets/takingCar/loading.gif" alt="" />
        </div>
        <div v-if="isLoadingEnd">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length > 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell v-for="(item, index) in list" :key="index">
                <div class="listOut">
                  <div class="listItem" @click="goToSeeDetail(item.id)">
                    <p class="time">
                      {{ item.publicized_at | timeFormatting }}
                    </p>
                    <div class="content">
                      <div class="titleDiv">
                        <p class="title">
                          <img
                            src="../../../assets/cms/stick.png"
                            v-if="item.weight > 0"
                          />{{ item.title }}
                        </p>
                        <div :class="{ isRead: item.read_status == 1 }"></div>
                      </div>
                      <div class="img">
                        <van-image
                          width="100%"
                          height="140px"
                          radius="4px"
                          fit="cover"
                          :src="item.images"
                        >
                          <!-- <template v-slot:error>
                            <img src="../../../assets/cms/notice.png" />
                          </template> -->
                        </van-image>
                      </div>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-pull-refresh>
          <van-row class="empty" v-if="list.length == 0">
            <van-col class="emptyMsg" span="24">
              <img src="../../../assets/member/nomessage.png" />
              <p class="tip1">暂无资讯消息</p>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      isLoadingEnd: false,
      //   下拉刷新
      isLoading: false, //加载中
      loading: false,
      finished: true,
      page: 1, //请求第几页
      total: 0, //总共的数据条数
      size: 10,
      list: [],
      isLoad: true,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.getDate();
  },
  filters: {
    timeFormatting(value) {
      return value.replace(/-/g, ".");
    },
  },
  methods: {
    // 加载更多
    onLoad() {
      this.page++;
      this.getDate();
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.finished = true;
      this.isLoadingEnd = false;
      this.list = [];
      this.getDate();
    },
    getDate() {
      this.$api
        .get("/cms-v2/member/article/list", {
          page: this.page,
          size: this.size,
          client: 1,
        })
        .then((res) => {
          this.list = this.list.concat(res.list);
          this.isLoadingEnd = true;
          this.loading = false;
          if (this.list.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    allRead() {
      this.$api
        .post("/cms-v2/member/article/readAll", {
          client: 1,
        })
        .then((res) => {
          this.list.forEach((item) => {
            item.read_status = 1;
          });
        });
    },
    // 查看详情
    goToSeeDetail(id) {
      this.$router.push({
        path: "/cms-article/detail",
        query: {
          id: id,
          token: this.$route.query.token,
          entranceChannel: 1,
          isApp: 1,
        },
      });
    },
  },
  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("list-content").style.height =
      winHeight - 100 + "px"; //调整上拉加载框高度
  },
};
</script>

<style lang="less">
body {
  min-height: 100%;
  background: #f5f6f7;
  height: auto;
  .van-nav-bar__title {
    font-size: 18px !important;
    font-weight: normal !important;
  }
  .article {
    height: 100%;
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
      .van-nav-bar__text {
        color: #333;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 27px;
      left: 0;
      z-index: 1;
    }
    &-content {
      //   background: #fff;
      padding: 16px;
      padding-top: 68px;
      box-sizing: border-box;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .loading {
        text-align: center;
        margin-top: 132px;
        img {
          width: 100px;
        }
      }
      .van-cell {
        background: #f5f6f7;
        padding: 0;
        .listOut {
          .listItem {
            margin-top: 16px;
            .time {
              text-align: center;
              margin-top: 16px;
              color: #999999;
              font-size: 12px;
              line-height: 12px;
            }
            .content {
              background-color: #ffffff;
              padding: 16px 12px;
              border-radius: 8px;
              margin-top: 12px;
              .titleDiv {
                display: flex;
                .title {
                  flex: 1;
                  font-size: 17px;
                  font-weight: bolder;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  /*! autoprefixer: off */
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  white-space: normal;
                  word-break: break-all;
                  word-wrap: break-word;
                  img {
                    width: 40px;
                    height: 18px;
                    margin-right: 5px;
                    position: relative;
                    top: 3.5px;
                  }
                }
                div {
                  margin-left: 8px;
                  margin-top: 8px;
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: #ff0000;
                }
                .isRead {
                  background-color: rgba(0, 0, 0, 0);
                }
              }
              .img {
                margin-top: 10px;
                img {
                  width: 100%;
                  height: 140px;
                  border-radius: 4px;
                }
              }
            }
          }
        }
      }
      .empty {
        padding-top: 132px;
        text-align: center;
        img {
          width: 100%;
        }
        .tip1 {
          color: #333;
          font-size: 13px;
          margin-top: 40px;
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
  .isiOSX {
    .article {
      &-title {
        padding-top: 44px;
      }
      &-reback {
        top: 45px;
      }
      &-content {
        padding-top: 98px;
      }
    }
  }
}
</style>
